import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import { Trash } from "iconsax-react";
import * as utils from "../../Utils/comman";
import Select from "react-select";

function ItemsAdd({ units, items, setItems, rowData }) {
  const [rawMaterials, setRawMaterials] = useState([
    {
      itemName: "",
      itemCode: "",
      unit: "",
      qty: "",
      category: "",
      categoryId: "",
    },
  ]);

  const [finishGood, setFinishGood] = useState([
    {
      itemName: "",
      itemCode: "",
      unit: "",
      qty: "",
      category: "",
      categoryId: "",
    },
  ]);

  const [consumableItems, setConsumableItems] = useState([
    {
      itemName: "",
      itemCode: "",
      unit: "",
      qty: "",
      category: "",
      categoryId: "",
    },
  ]);

  const [materialList, setMaterialList] = useState([]);

  useEffect(() => {
    if (rowData) {
      setRawMaterials(
        rowData.bom_recipe?.map((item) => ({
          id: item?.id,
          itemName: item.item_id,
          itemCode: item.item_code,
          unit: item.unitName,
          unitId: item.unit_id,
          qty: item.qty,
          category: item.category_name,
          categoryId: item.category,
        })) || []
      );

      setFinishGood(
        rowData.bom_finish_good?.map((item) => ({
          itemName: item.item_id,
          id: item?.id,
          itemCode: item.item_code,
          unit: item.unitName,
          unitId: item.unit_id,
          qty: item.qty,
          category: item.category_name,
          categoryId: item.category,
        })) || []
      );

      setConsumableItems(
        rowData.bom_consumable_item?.map((item) => ({
          itemName: item.item_id,
          itemCode: item.item_code,
          id: item?.id,
          unit: item.unitName,
          unitId: item.unit_id,
          qty: item.qty,
          category: item.category_name,
          categoryId: item.category,
        })) || []
      );
    }
  }, [rowData]);
  useEffect(() => {
    const updatedItems = [
      ...rawMaterials.map((item) => ({ ...item, label: "Raw Material" })),
      ...finishGood.map((item) => ({ ...item, label: "Finished Good" })),
      ...consumableItems.map((item) => ({ ...item, label: "Consumable Item" })),
    ];
    setItems(updatedItems);
  }, [rawMaterials, finishGood, consumableItems]);

  useEffect(() => {
    getMaterialList();
  }, []);

  const getMaterialList = () => {
    utils
      .callAPI("get", `/rawmaterial/list?page=0&per_page=0`)
      .then((res) => {
        if (res) {
          setMaterialList(res.result);
        }
      })
      .catch(() => setMaterialList([]));
  };

  useEffect(() => {
    if (rowData) {
      setRawMaterials(
        rowData.bom_recipe?.length
          ? rowData.bom_recipe.map((item) => ({
              id: item.id,
              itemName: item.item_id,
              itemCode: item.item_code,
              unit: item.unitName,
              unitId: item.unit_id,
              qty: item.qty,
              category: item.category_name,
              categoryId: item.category,
            }))
          : [
              {
                itemName: "",
                itemCode: "",
                unit: "",
                qty: "",
                category: "",
                categoryId: "",
              },
            ]
      );

      setFinishGood(
        rowData.bom_finish_good?.length
          ? rowData.bom_finish_good.map((item) => ({
              id: item.id,
              itemName: item.item_id,
              itemCode: item.item_code,
              unit: item.unitName,
              unitId: item.unit_id,
              qty: item.qty,
              category: item.category_name,
              categoryId: item.category,
            }))
          : [
              {
                itemName: "",
                itemCode: "",
                unit: "",
                qty: "",
                category: "",
                categoryId: "",
              },
            ]
      );

      setConsumableItems(
        rowData.bom_consumable_item?.length
          ? rowData.bom_consumable_item.map((item) => ({
              id: item.id,
              itemName: item.item_id,
              itemCode: item.item_code,
              unit: item.unitName,
              unitId: item.unit_id,
              qty: item.qty,
              category: item.category_name,
              categoryId: item.category,
            }))
          : [
              {
                itemName: "",
                itemCode: "",
                unit: "",
                qty: "",
                category: "",
                categoryId: "",
              },
            ]
      );
    }
  }, [rowData]);

  const handleItemChange = (index, field, value, setItems, items) => {
    const updatedItems = [...items];
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value,
    };

    if (field === "itemName") {
      const selectedItem = materialList.find((m) => m.id === value);
      if (selectedItem) {
        const unitObj = units.find((u) => u.name === selectedItem.name);
        updatedItems[index] = {
          ...updatedItems[index],
          unit: unitObj ? unitObj.name : "",
          unitId: unitObj ? unitObj.id : null,
          itemCode: selectedItem.product_code,
          categoryId: selectedItem.category_id,
          category: selectedItem.category_name,
          category_name: selectedItem.category_name,
        };
      }
    }

    setItems(updatedItems);
  };

  const handleAddRow = (setItems, items, maxLimit = null) => {
    if (maxLimit && items.length >= maxLimit) return;
    setItems([
      ...items,
      { itemName: "", itemCode: "", unit: "", qty: "", category: "" },
    ]);
  };

  const handleDeleteRow = (index, setState) => {
    setState((prevState) => {
      let updated = [...prevState];

      const nonDeletedIndexes = updated
        .map((item, idx) => (!item.isDelete ? idx : null))
        .filter((idx) => idx !== null);

      if (updated[index]?.id) {
        // Edit mode
        if (nonDeletedIndexes.length === 1) {
          const lastIdx = nonDeletedIndexes[0];

          // Just clear the data ,— don't mark as deleted
          updated[lastIdx] = {
            ...updated[lastIdx],
            isDelete: true,
            itemName: "",
            itemCode: "",
            unit: "",
            unitId: "",
            qty: "",
            category: "",
            categoryId: "",
          };

          updated.push({
            itemName: "",
            itemCode: "",
            unit: "",
            unitId: "",
            qty: "",
            category: "",
            categoryId: "",
          });
        } else {
          // More than one → mark clicked row as deleted
          updated[index] = { ...updated[index], isDelete: true };
        }
      } else {
        // Add mode
        updated.splice(index, 1);
        if (updated.length === 0) {
          updated.push({
            itemName: "",
            itemCode: "",
            unit: "",
            unitId: "",
            qty: "",
            category: "",
            categoryId: "",
          });
        }
      }
      return updated;
    });
  };

  const renderTable = (title, items, setItems, allowMultiple = true) => {
    const filteredMaterialList =
      title === "Consumable Items" || title === "Finish Good"
        ? materialList.filter((material) => material.isconsumable === "yes")
        : materialList;
    const materialOptions = filteredMaterialList.map((material) => ({
      label: material.product_name,
      value: material.id,
    }));

    return (
      <>
        <h6>{title}</h6>
        <hr className="hr-lg mt-1" />
        <div className="table-responsive">
          <RB.Table striped bordered hover>
            <thead>
              <tr>
                <th>Select Items</th>
                <th>Item Code</th>
                <th>Unit</th>
                <th>Qty</th>
                <th>Select Category</th>
                {allowMultiple && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {items
                .filter((item) => !item.isDelete)
                .map((item) => {
                  const realIndex = items.indexOf(item); // get actual index in full array
                  return (
                    <tr key={realIndex}>
                      <td className="p-1">
                        <Select
                          className="raw-material-select"
                          classNamePrefix="raw-select"
                          options={materialOptions}
                          value={
                            materialOptions.find(
                              (opt) => opt.value === item.itemName
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            handleItemChange(
                              realIndex, // ✅ correct index
                              "itemName",
                              selectedOption?.value,
                              setItems,
                              items
                            )
                          }
                          placeholder="Select Item..."
                          isClearable
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          menuPosition="fixed"
                        />
                      </td>
                      <td className="p-1">
                        <RB.Form.Control
                          type="text"
                          value={item.itemCode}
                          readOnly
                        />
                      </td>
                      <td className="p-1">
                        <RB.Form.Control
                          type="text"
                          value={item.unit}
                          readOnly
                        />
                      </td>
                      <td className="p-1">
                        <RB.Form.Control
                          type="text"
                          value={item.qty}
                           onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d*\.?\d*$/.test(val)) {
                              // ✅ Allow digits and one decimal point
                              handleItemChange(
                                realIndex,
                                "qty",
                                val,
                                setItems,
                                items
                              );
                            }
                          }}
                        />
                      </td>
                      <td className="p-1">
                        <RB.Form.Control
                          type="text"
                          value={item.category || item.category_name || ""}
                          readOnly
                        />
                      </td>
                      <td>
                        <RB.Button
                          className="btn-flat"
                          title="Delete"
                          onClick={() => handleDeleteRow(realIndex, setItems)} // ✅ correct index
                        >
                          <Trash />
                        </RB.Button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </RB.Table>
          {allowMultiple && (
            <RB.Button
              size="sm"
              className="btn btn-primary mb-3"
              onClick={() =>
                handleAddRow(setItems, items, allowMultiple ? null : 1)
              }
            >
              Add New
            </RB.Button>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      {renderTable("Raw Material", rawMaterials, setRawMaterials)}
      {renderTable("Finish Good", finishGood, setFinishGood, false)}
      {renderTable(
        "Consumable Items",
        consumableItems,
        setConsumableItems,
        true
      )}
    </>
  );
}

export default ItemsAdd;
